import React from "react";
import { useFormikContext } from "formik";
import Theme from "@adsk/alloy-react-theme";
import {
  LocationNode,
  LocationPicker,
  useLocations,
} from "@adsk/acc-locations-components";
import { FieldWrapper } from "@adsk/acc-issues-common/components/primitive/FieldWrapper";
import { useTranslations } from "@adsk/acc-issues-translations";
import { IssueAttributes } from "@adsk/acc-issues-types";

export const LocationCreateField = ({
  isRequired = false,
  errorMessage,
}: {
  errorMessage?: string | null;
  isRequired?: boolean;
}) => {
  const { T } = useTranslations();
  const { isLoading } = useLocations();
  const { setFieldValue, values } = useFormikContext<IssueAttributes>();

  return (
    <FieldWrapper
      label={T.translate("issueAttributes.location")}
      loading={isLoading}
      required={isRequired}
      errorMessage={errorMessage}
      testId="location-field"
    >
      <LocationPicker
        style={
          !!errorMessage
            ? { border: `1px solid ${Theme.colors.red500}`, borderRadius: 2 }
            : undefined
        }
        selectedNodeId={values.locationId}
        hideIncludeSubLocations
        clearable
        onNodeSelect={location =>
          setFieldValue(
            "locationId",
            location ? (location as LocationNode).id : null
          )
        }
        data-testid="create-issue-modal-locationid"
      />
    </FieldWrapper>
  );
};
